import { render, staticRenderFns } from "./MpsUsageDetail.vue?vue&type=template&id=0f5b4faa&scoped=true"
import script from "./MpsUsageDetail.vue?vue&type=script&lang=js"
export * from "./MpsUsageDetail.vue?vue&type=script&lang=js"
import style0 from "./MpsUsageDetail.vue?vue&type=style&index=0&id=0f5b4faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5b4faa",
  null
  
)

export default component.exports